import { ThemeProvider } from '@positivote/design-system/providers'

export function Contexts({ children }: { children: React.ReactNode }): JSX.Element {
  return [ThemeProvider].reduce(
    (AccumulatedProviders, CurrentProvider) =>
      // eslint-disable-next-line react/display-name
      ({ children: currentChildren }: { children: React.ReactNode }) => {
        return (
          <AccumulatedProviders>
            <CurrentProvider>{currentChildren}</CurrentProvider>
          </AccumulatedProviders>
        )
      },
    ({ children: currentChildren }) => <>{currentChildren}</>
  )({ children })
}
